import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Modal, AddOffer, InfluencerRating } from "../../Components";
import Toast from "../../Components/Base/Form/Toast";
import LoadingBackDrop from "../../Components/Base/Common/LoadingBackDrop";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { campaignsApplicationService } from "../../Services/campaignApplication.service";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Table,
  TableBody,
  TableHead,
  TableContainer,
  Paper,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { searchProfileService } from "../../Services";
import AppDeleteDialog from "../../Components/AppDeleteDialog";
import { storageHandler } from "../../Helpers";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import { CircleCheckBig, CircleX,  MessageCircleMore } from "lucide-react";

const TruncatedText = styled("div")(() => ({
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  "&:hover": {
    cursor: "default",
  },
}));

const CampaignHeader = styled("div")(() => ({
  marginBottom: "10px",
  // borderBottom: "1px solid #e9ecef",
}));

const CampaignTitle = styled("h1")(() => ({
  fontSize: "2rem",
  fontWeight: "400",
  color: "#333333",
  margin: "0",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  fontFamily: "inherit",
}));

// const EditIcon = styled("span")(() => ({
//   cursor: "pointer",
//   padding: "4px",
//   borderRadius: "4px",
//   transition: "background-color 0.2s ease",
//   "&:hover": {
//     backgroundColor: "#f5f5f5",
//   },
// }));

export default function CampaignApplication({
  cartItem,
  closeCartPanel,
  setAuth,
  setModalSwitch,
  NotifModul,
  profiles,
  user,
  setModalNotification,
  setCartItem,
  setShowCart,
}) {
  const [isloaded, setIsLoaded] = React.useState(false);
  const [toastList, setToastList] = useState([]);
  const [applicationData, setApplicationData] = useState([]);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const campaignId = searchParams.get("id");
  const campaignTitle =
    location.state?.campaignTitle || "Campaign Applications";

  // Modal and influencer data states
  const [modal, setModal] = useState(null);
  const [influencerProfile, setInfluencerProfile] = useState(null);
  const [influencerUserType, setInfluencerUserType] = useState("");
  const [selectedInfluencer, setSelectedInfluencer] = useState(null);

  // Social media module states
  const [instModul, setInstModul] = useState([]);
  const [fcbkModul, setFcbkModul] = useState([]);
  const [tiktokModul, setTiktokModul] = useState([]);
  const [youtubeModul, setYoutubeModul] = useState([]);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const navigate = useNavigate();
  // Function to handle reject button click
  const handleApplication = async (application, status) => {
    try {
      await campaignsApplicationService.rejectApplication(application.id, {
        status: status || "rejected",
      });
      setApplicationData((prev) =>
        prev.map((app) =>
          app.id === application.id
            ? { ...app, status: status || "rejected" }
            : app
        )
      );
      setToastList((prev) => [
        ...prev,

        {
          error: false,
          msg: `Successfully rejected application from ${
            application?.inf_handle ||
            application?.inf_name ||
            application?.name
          }`,
          id: `${Date.now()}-${prev.length}`,
        },
      ]);
    } catch (error) {
      // setToastList((prev) => [
      //   ...prev,
      //   {
      //     error: true,
      //     msg:
      //       error.response?.data?.message ||
      //       error.message ||
      //       "Failed to reject application. Please try again.",
      //     id: `${Date.now()}-${prev.length}`,
      //   },
      // ]);
    }
  };

  // useEffect(() => {
  //   info();
  // }, []);

  // const info = async () => {

  // };

  // Function to handle Send Offer button click with dummy data
  const handleSendOffer = async (application) => {
    console.log(
      "🚀 ~ handleSendOffer ~ application:",
      application.social_media_code
    );
    let InfluencerProfile;

    // // Handle application rejection
    await handleApplicationRejection(application);

    // // Fetch influencer profile
    InfluencerProfile = await fetchInfluencerProfile(application);
    console.log("🚀 ~ handleSendOffer ~ InfluencerProfile:", InfluencerProfile);

    // // Set selected influencer and user type
    setupInfluencerData(
      application,
      InfluencerProfile,
      application.social_media_code
    );

    // // Open modal
    setModal("addOffer");
  };

  // Helper function to handle application rejection
  const handleApplicationRejection = async (application) => {
    try {
      await campaignsApplicationService.sendOffer(application.id, {
        status: "rejected",
      });

      const influencerName =
        application?.inf_handle || application?.inf_name || application?.name;

      setToastList((prev) => [
        ...prev,
        {
          error: false,
          msg: `Successfully rejected application from ${influencerName}`,
          id: `${Date.now()}-${prev.length}`,
        },
      ]);
    } catch (error) {
      // Error handling is commented out as per original code
      // setToastList((prev) => [
      //   ...prev,
      //   {
      //     error: true,
      //     msg: error.response?.data?.message ||
      //          error.message ||
      //          "Failed to reject application. Please try again.",
      //     id: `${Date.now()}-${prev.length}`,
      //   },
      // ]);
    }
  };

  // Helper function to fetch influencer profile
  const fetchInfluencerProfile = async (application) => {
    console.log("🚀 ~ fetchInfluencerProfile ~ application:", application);
    try {
      const res = await searchProfileService.searchInfluencerProfile(
        application.inf_user_id,
        // "r"
        application?.inf_type
      );
      console.log("🚀 ~ info ~ res:", res.data);
      setInfluencerProfile(res.data);
      return res.data;
    } catch (error) {
      console.error("❌ Error in searchInfluencerProfile:", error);
      return null;
    }
  };

  // Helper function to setup influencer data and platform modules
  const setupInfluencerData = (
    application,
    InfluencerProfile,
    social_media_code
  ) => {
    setSelectedInfluencer(application);

    // const userType = platformMap[application.platform] || "instagram";
    let userType = JSON.parse(storageHandler.getUserTypeForProfileItem());
    setInfluencerUserType(userType);

    // Setup platform-specific product rates
    setupPlatformModules(InfluencerProfile, social_media_code);
  };

  // Helper function to filter and set platform modules
  const setupPlatformModules = (InfluencerProfile, social_media_code) => {
    const platformFilters = {
      IG: (rates) => rates?.filter((item) => item?.platform === "IG"),
      FB: (rates) => rates?.filter((item) => item?.platform === "FB"),
      TT: (rates) => rates?.filter((item) => item?.platform === "TT"), // corrected "f" → "TT"
      YT: (rates) => rates?.filter((item) => item?.platform === "YT"),
    };

    const productRates = InfluencerProfile?.product_rates;

    if (!social_media_code || !platformFilters[social_media_code]) return;

    const filteredRates = platformFilters[social_media_code](productRates);

    switch (social_media_code) {
      case "IG":
        setInstModul(filteredRates);
        break;
      case "FB":
        setFcbkModul(filteredRates);
        break;
      case "TT":
        setTiktokModul(filteredRates);
        break;
      case "YT":
        setYoutubeModul(filteredRates);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const fetchApplicationData = async () => {
      if (campaignId) {
        try {
          setIsLoaded(false);
          const response =
            await campaignsApplicationService.getCampaignApplicationById(
              campaignId
            );
          const apiData = response.data || [];
          console.log("🚀 ~ fetchApplicationData ~ apiData:", apiData);

          if (apiData.length === 0) {
            // setApplicationData(dummyApplicationData);
          } else {
            setApplicationData(apiData);
          }

          // setToastList((prev) => [
          //   ...prev,
          //   {
          //     error: false,
          //     msg: `Loaded applications for campaign ${campaignId}`,
          //     id: `${Date.now()}-${prev.length}`,
          //   },
          // ]);
        } catch (error) {
          // setApplicationData(dummyApplicationData);
          // setToastList((prev) => [
          //   ...prev,
          //   {
          //     error: true,
          //     msg: "Failed to load application data. Using sample data.",
          //     id: `${Date.now()}-${prev.length}`,
          //   },
          // ]);
        } finally {
          setIsLoaded(true);
        }
      }
    };

    fetchApplicationData();
  }, [campaignId]); // Only depend on campaignId
  console.log("🚀 ~ applicationData:", applicationData);

  const handleChat = (e, item) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (item?.inf_user_id) {
      navigate(`/brand/chat?userId=${item.inf_user_id}`);
    }
  };

  return (
    <>
      <div className="main">
        <div className="main__inner">
          <LoadingBackDrop
            open={!isloaded}
            message="Loading applications..."
            size={60}
            thickness={4}
          />
          <div className="bg-white border p-4 rounded-xl">
            <CampaignHeader>
              <CampaignTitle>
                {campaignTitle}
                {/* <EditIcon>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </EditIcon> */}
              </CampaignTitle>
            </CampaignHeader>

            <TableContainer
              component={Paper}
              elevation={3}
              className="!rounded-2xl"
            >
              <Table>
                <TableHead className="bg-gray-200">
                  <TableRow>
                    <TableCell sx={{ py: 1, minWidth: "100px" }}>
                      TAMA score
                    </TableCell>
                    <TableCell sx={{ py: 1, minWidth: "100px" }}>
                      Name
                    </TableCell>
                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Platform
                    </TableCell>
                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Followers
                    </TableCell>
                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Asking Price
                    </TableCell>

                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Message
                    </TableCell>

                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Status
                    </TableCell>
                    {/* <TableCell sx={{ py: 1, textAlign: "center" }}>Delivery Date</TableCell> */}
                    {/* <TableCell sx={{ py: 1, textAlign: "center" }}>Status</TableCell> */}
                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {applicationData.length > 0 ? (
                    applicationData.map((item, index) => (
                      <TableRow key={index}>
                        {/* TAMA score column */}
                        <TableCell sx={{ minWidth: "100px" }}>
                          <InfluencerRating infrating={item?.inf_rating} />
                        </TableCell>
                        <TableCell sx={{ minWidth: "100px" }}>
                          <div className="flex items-center">
                            <div className="w-10 h-10 mr-3">
                              <img
                                src={
                                  item?.inf_profile_img_url ||
                                  "/images/placeholder/avatar.png"
                                }
                                alt="Profile"
                                className="w-10 h-10 rounded-full object-cover"
                                onError={(e) => {
                                  e.target.src =
                                    "/images/placeholder/avatar.png";
                                }}
                              />
                            </div>
                            <div>
                              {item?.inf_user_id ? (
                                <a
                                  href={`/#/brand/influencerProfile/${item?.inf_user_id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {item?.inf_displayname ||
                                    item?.inf_name ||
                                    item?.name ||
                                    "N/A"}
                                </a>
                              ) : (
                                <span>
                                  {item?.inf_handle ||
                                    item?.inf_name ||
                                    item?.name ||
                                    "N/A"}
                                </span>
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <div className="flex justify-center">
                            {(() => {
                              switch (item?.platform_id?.toString()) {
                                case "1":
                                  return (
                                    <img
                                      src="/images/instagram.svg"
                                      alt="Instagram"
                                      width="24"
                                      height="24"
                                    />
                                  );
                                case "2":
                                  return (
                                    <img
                                      src="/images/tiktok-logo.svg"
                                      alt="TikTok"
                                      width="24"
                                      height="24"
                                    />
                                  );
                                case "3":
                                  return (
                                    <img
                                      src="/images/facebook.svg"
                                      alt="Facebook"
                                      width="24"
                                      height="24"
                                    />
                                  );
                                case "4":
                                  return (
                                    <img
                                      src="/images/youtube.svg"
                                      alt="YouTube"
                                      width="24"
                                      height="24"
                                    />
                                  );
                                default:
                                  return item?.platform || "N/A";
                              }
                            })()}
                          </div>
                        </TableCell>

                        {/* Followers column */}
                        <TableCell sx={{ textAlign: "center" }}>
                          {item?.inf_followers || "N/A"}
                        </TableCell>

                        {/* Engagements column */}
                        <TableCell sx={{ textAlign: "center" }}>
                          {item?.rate || "N/A"}
                          {item?.rate_currency ? ` ${item?.rate_currency}` : ""}
                        </TableCell>

                        {/* Notes column */}
                        <TableCell sx={{ textAlign: "center" }}>
                          <Tooltip
                            title={item?.note || "No notes available"}
                            arrow
                            placement="top"
                          >
                            <TruncatedText className="text-sm">
                              {item?.note?.length > 30
                                ? item?.note?.slice(0, 10) + "..."
                                : item?.note || "N/A"}
                            </TruncatedText>
                          </Tooltip>
                        </TableCell>

                        <TableCell sx={{ textAlign: "center" }}>
                          <span
                            className={`inline-block capitalize  px-3 py-1 rounded-full text-sm font-medium ${
                              item?.status === "pending"
                                ? "!bg-yellow-100 !text-yellow-700"
                                : item?.status === "rejected"
                                ? "!bg-red-100 !text-red-700"
                                : "!bg-gray-100 !text-gray-700"
                            }`}
                          >
                            {item?.status || "N/A"}
                          </span>
                        </TableCell>

                        {item?.status === "pending" && (
                          <TableCell sx={{ textAlign: "center" }}>
                            <div>
                              <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <button
                                    className="p-2 text-gray-600 hover:text-blue-600 "
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <MoreVertIcon />
                                  </button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent
                                  align="end"
                                  className="w-[180px] border border-gray-200 bg-white p-2 rounded-lg shadow-lg mt-1 z-50"
                                >
                                  <DropdownMenuItem
                                    onSelect={(e) => handleChat(e, item)}
                                    className="cursor-pointer text-black font-semibold hover:bg-green-50 p-2 rounded-md flex gap-1"
                                  >
                                    <MessageCircleMore className="mr-2 h-4 w-4" />
                                    Chat
                                  </DropdownMenuItem>
                                  <DropdownMenuItem
                                    onClick={() => {
                                      handleSendOffer(item);
                                      setSelectedApplication(item);
                                    }}
                                    className="cursor-pointer hover:bg-green-50 font-semibold p-2 rounded-md flex gap-1 text-green-500"
                                  >
                                    <CircleCheckBig className="mr-2 h-4 w-4" />
                                    Send Offer
                                  </DropdownMenuItem>
                                  <DropdownMenuItem
                                    onClick={() => {
                                      setSelectedApplication(item);
                                      setIsDeleteDialogOpen(true);
                                    }}
                                    className="cursor-pointer font-semibold hover:bg-green-50 p-2 rounded-md flex gap-1 text-red-500"
                                  >
                                    <CircleX className="mr-2 h-4 w-4" />
                                    Reject
                                  </DropdownMenuItem>
                                </DropdownMenuContent>
                              </DropdownMenu>
                            </div>
                          </TableCell>
                        )}
                        {item?.status === "rejected" && (
                          <TableCell sx={{ textAlign: "center" }}>
                            {/* <div className="flex space-x-2 justify-center">
                            <Tooltip title="withdraw" arrow>
                              <Button
                                variant="contained"
                                color="error"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleApplication(item, "offred");
                                }}
                                size="small"
                              >
                                Withdraw
                              </Button>
                            </Tooltip>
                          </div> */}
                            -
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        {campaignId
                          ? "No applications found for this campaign"
                          : "No campaign ID specified"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>

      {/* AddOffer Modal - Same structure as InfluencerProfile */}
      {modal === "addOffer" && (
        <Modal addClass="modalAsset" close={() => setModal(null)}>
          <div className="modal__asset">
            <div className="modal__asset-inner">
              <AddOffer
                user={user}
                instModul={instModul}
                fcbkModul={fcbkModul}
                tiktokModul={tiktokModul}
                youtubeModul={youtubeModul}
                setModal={setModal}
                setToastList={setToastList}
                influencerProfile={influencerProfile}
                toastList={toastList}
                cartItem={cartItem}
                setCartItem={setCartItem}
                setShowCart={setShowCart}
                influencerUserType={influencerUserType}
                selectedApplication={selectedApplication}
              />
            </div>
          </div>
        </Modal>
      )}
      {isDeleteDialogOpen && selectedApplication && (
        <AppDeleteDialog
          //  isLoading={deleteLoading}
          isOpen={isDeleteDialogOpen}
          title="Reject Application"
          description={`Are you sure you want to application by'${selectedApplication.inf_displayname}' ?`}
          onConfirm={async () => {
            await handleApplication(selectedApplication, "rejected");
            setIsDeleteDialogOpen(false);
            setSelectedApplication(null);
          }}
          onClose={() => {
            setIsDeleteDialogOpen(false);
            setSelectedApplication(null);
          }}
        />
      )}

      <AnimatePresence></AnimatePresence>

      {toastList && (
        <Toast type="rate" list={toastList} setList={setToastList} />
      )}
    </>
  );
}
